module.exports = __webpack_public_path__ + "img/build1040.e214e2a8.png";